import type { JSX } from 'react';
import { DialogContainer } from '../dialogs/dialogcontainer';

export class DialogManager
{
    static dialogContainer : DialogContainer | undefined;

    static close() : void
    {
        DialogManager.dialogContainer!.closeModal();
    }

    static init(modalContext : any) : void
    {
        DialogManager.dialogContainer = modalContext;
    }

    static open(component : JSX.Element) : void
    {
        DialogManager.dialogContainer!.openModal(component);
    }
};

